




























import Vue from 'vue'
import CloseButton from '@/components/CloseButton.vue'
import { mapGetters } from 'vuex'
import tenantNavMixin from '@/mixins/tenant-nav-mixin'
export default Vue.extend({
    components: { CloseButton },
    mixins: [tenantNavMixin],
    data() {
        return {
            loading: false,
            password: '',
            showPassword: false,
            xero_id: null
        }
    },
    computed: {
        ...mapGetters(['userTmp'])
    },
    methods: {
        async linkAccounts(): Promise<void> {
            //  validate the form
            const valid = await this.$validator.validate()

            //  If the form is NOT valid, do nothing
            if (!valid) return

            //  Else, assemble request payload
            const payload = {
                email: this.userTmp.email,
                password: this.password
            }

            //  Start the loading spinner
            this.loading = true

            //  Send the request
            const user = await this.$store.dispatch('linkXeroAccount', payload)

            //  Stop the loading spinner
            this.loading = false

            //  If the request failed, do nothing
            if (!user) return

            //  Else, use standard login
            this.routeLogin(user)
        }
    }
})
